import { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { FilterContext, FilterDispatchContext } from "../../Context/FilterContext";

const PROPERTY_TYPES = [
  { value: "", label: "All types" },
  { value: "house", label: "House" },
  { value: "condominium", label: "Condominium" },
  { value: "residential_lot", label: "Residential Lot" },
  { value: "commercial_lot", label: "Commercial Lot" },
  { value: "commercial_building", label: "Commercial Building" },
  { value: "office", label: "Office" },
  { value: "industrial", label: "Industrial" },
  { value: "agricultural", label: "Agricultural" },
  { value: "beach", label: "Beach" },
];

const Wrapper = styled.div`
  position: relative;

  .type-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    border: none;
    border-radius: 8px;
    background: #fff;
    font-size: 14px;
    color: var(--primary-grey-500);
    cursor: pointer;
    box-shadow: var(--elevation-1dp);
    transition: all 150ms ease;
    white-space: nowrap;

    &:hover, &.open {
      box-shadow: var(--elevation-2dp);
    }

    &.active {
      background: var(--primary-100);
    }
  }

  .type-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 100;
    width: 220px;
    max-height: 360px;
    overflow-y: auto;
    background: #fff;
    border-radius: 8px;
    box-shadow: var(--elevation-2dp);

    .type-option {
      padding: 10px 14px;
      font-size: 14px;
      cursor: pointer;
      color: var(--primary-grey-500);
      text-transform: capitalize;
      transition: background 100ms;

      &:hover {
        background: var(--background-grey-100);
      }

      &.selected {
        background: var(--primary-100);
        font-weight: 600;
      }
    }
  }
`;

const PropertyTypeDropdown = () => {
  const filters = useContext(FilterContext) || {};
  const dispatch = useContext(FilterDispatchContext);
  const currentType = filters.propertyType || "";

  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    if (value === "") {
      dispatch({ action: "delete", filter: { key: "propertyType" } });
    } else {
      dispatch({ action: "set", filter: { key: "propertyType", value } });
    }
    setOpen(false);
  };

  const currentLabel = PROPERTY_TYPES.find((t) => t.value === currentType)?.label || "Property type";
  const isActive = !!currentType;

  return (
    <Wrapper ref={wrapperRef}>
      <button
        type="button"
        className={`type-trigger${open ? " open" : ""}${isActive ? " active" : ""}`}
        onClick={() => setOpen(!open)}
      >
        {currentLabel}
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
          <path d="M2 4l3 3 3-3"/>
        </svg>
      </button>

      {open && (
        <div className="type-dropdown">
          {PROPERTY_TYPES.map((type) => (
            <div
              key={type.value || "__all__"}
              className={`type-option${type.value === currentType || (type.value === "" && !currentType) ? " selected" : ""}`}
              onClick={() => handleSelect(type.value)}
            >
              {type.label}
            </div>
          ))}
        </div>
      )}
    </Wrapper>
  );
};

export default PropertyTypeDropdown;
